import '../../styles-new/pages/category.scss';
import generateTabs from '../components/generateTabs';
import '../components/war-slider';


generateTabs('sidebar-last', { isLoadMore: false });
